let data = [
  // {
  //   role: 'Optics SW Engineer',
  //   location: 'Seoul, South Korea',
  //   description: 
  //   `We are looking for an experienced Optics SW Engineer with expertise in optical design tools such as Zemax or CodeV. In this role, you will work closely with software engineers to develop ray tracing and point spread function (PSF) generation tools. You'll also collaborate with a cross-functional team to optimize the entire computer vision system by creating novel optical solutions for imaging sensors.
    
  //   Key Responsibilities:
    
  //   1. Optical Sensor Design:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Design and optimize optical systems for sensor applications, including imaging systems, lenses, and light sources using tools like Zemax and CodeV.</li>
  //     <li>Simulate optical behavior and assess performance across various operating conditions to ensure high image quality and sensor performance.</li>
  //   </ul>
  //   2. Ray Tracing and PSF Generation:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Collaborate with software engineers to develop ray tracing models and point spread function generation tools to improve sensor accuracy.</li>
  //     <li>Implement simulation techniques to predict sensor behavior in real-world conditions.</li>
  //   </ul>
  //   3. System-Level Optimization:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Work with cross-functional teams to integrate optical designs into a full imaging pipeline, from illuminants to processing algorithms.</li>
  //     <li>Ensure that optical systems meet system-level performance criteria and enhance the sensor’s functionality in the broader system.</li>
  //   </ul>
  //   4. Sensor Performance Evaluation:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Design and execute experiments to test optical system performance under varying environmental conditions such as light levels and temperature fluctuations.</li>
  //     <li>Analyze test results to refine optical designs and improve overall sensor performance.</li>
  //   </ul>
  //   5. Innovative Solutions:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Develop innovative optical solutions that contribute to the optimization of the entire computer vision system.</li>
  //     <li>Utilize state-of-the-art optical modeling tools to identify and solve performance bottlenecks.</li>
  //   </ul>
  //   6. Collaboration and Cross-Disciplinary Integration:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Collaborate with hardware, software, and algorithm teams to integrate optical designs with sensor technologies.</li>
  //     <li>Stay up to date with advancements in optical engineering and sensor design to ensure cutting-edge solutions for the team.</li>
  //   </ul>
  //   Required Qualifications:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Bachelor’s or Master’s degree in Optical Engineering, Physics, Electrical Engineering, or a related field.</li>
  //     <li>3+ years of experience in optical design, with a focus on optical systems for sensors or imaging applications.</li>
  //     <li>Programming experience in at least one of the coding languages: C, C++, Python</li>
  //     <li>Proficiency with optical design software such as Zemax, CodeV, or similar tools.</li>
  //     <li>Strong understanding of optical principles, including light propagation, ray tracing, and lens design.</li>
  //     <li>Excellent problem-solving skills and ability to collaborate effectively in a multidisciplinary team.</li>
  //   </ul>
  //   Preferred Qualifications:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Experience with ray tracing and point spread function generation for sensor applications.</li>
  //     <li>Familiarity with imaging sensors and their integration into computer vision systems.</li>
  //     <li>Knowledge of digital twin simulators or related simulation tools.</li>
  //     <li>Experience with AI/ML-based techniques for sensor optimization.</li>
  //   </ul>
  //   Why Join Us?
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Be part of a pioneering team shaping the future of sensor technologies in computer vision systems.</li>
  //     <li>Work on innovative projects that integrate optical design with cutting-edge sensor and software technologies.</li>
  //     <li>Collaborative work environment with ample opportunities for growth and professional development.</li>
  //   </ul>`
    
  // },
  // {
  //   role: 'Sensor Engineer',
  //   location: 'Seoul, South Korea',
  //   description: 
  //   `We are seeking a Sensor Characterization Engineer to lead the evaluation and optimization of imaging sensors for our state-of-the-art computer vision systems. This role involves analyzing sensor performance, optimizing calibration, and ensuring seamless integration within our end-to-end imaging pipeline, including illuminants, optics, actuators, and algorithms.
    
  //   Key Responsibilities:
    
  //   1. Sensor Evaluation and Testing:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Perform in-depth characterization of imaging sensors, including CMOS and CCD technologies, across various conditions (light levels, temperatures, etc.).</li>
  //     <li>Design and execute experiments to assess parameters such as sensitivity, dynamic range, noise, linearity, and color accuracy.</li>
  //   </ul>
  //   2. System Integration:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Collaborate with cross-functional teams to integrate sensors into the full imaging pipeline, from illuminants to image processing algorithms.</li>
  //     <li>Ensure sensor performance aligns with system-level requirements and end-use applications.</li>
  //   </ul>
  //   3. Calibration and Optimization:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Develop and implement sensor calibration procedures, including dark current, white balance, and defect pixel correction.</li>
  //     <li>Optimize sensor settings (exposure, gain, etc.) to maximize image quality and minimize artifacts.</li>
  //   </ul>
  //   4. Simulation and Modeling:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Utilize digital twin simulators and other modeling tools to predict sensor behavior and identify performance bottlenecks.</li>
  //     <li>Validate simulation results against real-world measurements to improve accuracy and reliability.</li>
  //   </ul>
  //   5. Data Analysis and Reporting:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Analyze experimental and field data to derive actionable insights for sensor performance improvements.</li>
  //     <li>Prepare detailed technical documentation, reports, and presentations for internal and external stakeholders.</li>
  //   </ul>
  //   6. Collaboration and Innovation:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Work closely with hardware, software, and algorithm teams to ensure end-to-end system optimization.</li>
  //     <li>Stay up-to-date with the latest advancements in sensor technologies and provide recommendations for new implementations.</li>
  //   </ul>
  //   Required Qualifications:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Bachelor’s or Master’s degree in Electrical Engineering, Computer Engineering, Physics, or a related field.</li>
  //     <li>3+ years of experience in imaging sensor evaluation and characterization.</li>
  //     <li>Strong understanding of sensor technologies (e.g., CMOS, CCD) and their performance metrics.</li>
  //     <li>Hands-on experience with test equipment such as oscilloscopes, spectrometers, and light sources.</li>
  //     <li>Proficiency in programming/scripting languages (e.g., Python, MATLAB, or C++) for data analysis and automation.</li>
  //     <li>Familiarity with image processing concepts and tools, including color science and ISP tuning.</li>
  //     <li>Excellent problem-solving skills and attention to detail.</li>
  //   </ul>
  //   Preferred Qualifications:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Experience with end-to-end imaging systems or computer vision applications.</li>
  //     <li>Knowledge of digital twin simulators or related simulation technologies.</li>
  //     <li>Understanding of optical systems, including lenses and illumination design.</li>
  //     <li>Familiarity with AI/ML-based approaches for sensor optimization and calibration.</li>
  //   </ul>
  //   Why Join Us?
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Be part of a pioneering team shaping the future of imaging and computer vision.</li>
  //     <li>Work on impactful projects that integrate hardware and software for innovative solutions.</li>
  //     <li>Collaborative work environment with opportunities for growth and professional development.</li>
  //   </ul>`
  // }, 
  // {
  //   role: 'Software Engineer',
  //   location: 'Seoul, South Korea',
  //   description: 
  //   `We are looking for a talented Software Engineer to join our dynamic team, focused on developing cutting-edge software solutions for our computer vision systems. In this role, you will collaborate with hardware engineers, optical engineers, and algorithm specialists to design, build, and optimize software that drives the next generation of imaging technology.

  //   Key Responsibilities:

  //   1. Software Development and Integration:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Design, develop, and maintain software solutions that support our computer vision systems and imaging sensors.</li>
  //     <li>Integrate software with optical hardware and sensors to ensure seamless functionality across the entire imaging pipeline.</li>
  //   </ul>
  //   2. Algorithm Development and Optimization:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Collaborate with algorithm engineers to implement and optimize image processing and computer vision algorithms.</li>
  //     <li>Develop efficient code to process and analyze large image datasets, focusing on speed, accuracy, and scalability.</li>
  //   </ul>
  //   3. Performance Tuning:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Analyze software performance and identify bottlenecks in the imaging pipeline.</li>
  //     <li>Optimize code for maximum performance, ensuring real-time or near-real-time processing capabilities.</li>
  //   </ul>
  //   4. Cross-Functional Collaboration:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Work closely with hardware and optical engineering teams to ensure software and hardware integration meets system-level requirements.</li>
  //     <li>Collaborate with sensor engineers to ensure smooth integration of sensor data into software frameworks.</li>
  //   </ul>
  //   5. Testing and Quality Assurance:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Develop and execute automated tests to ensure the stability, reliability, and performance of the software.</li>
  //     <li>Participate in code reviews and ensure the adherence to best practices in software development.</li>
  //   </ul>
  //   6. Documentation and Reporting:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Create clear, concise, and thorough technical documentation for the software and algorithms developed.</li>
  //     <li>Provide regular updates on project progress and communicate effectively with stakeholders across the organization.</li>
  //   </ul>
  //   Required Qualifications:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Bachelor’s or Master’s degree in Computer Science, Software Engineering, Electrical Engineering, or a related field.</li>
  //     <li>3+ years of experience in software development, preferably in image processing or computer vision applications.</li>
  //     <li>Strong programming skills in languages such as Python, C++, or Java, with experience in software design and development.</li>
  //     <li>Experience with computer vision libraries and frameworks (e.g., OpenCV, TensorFlow, PyTorch) and familiarity with image processing techniques.</li>
  //     <li>Familiarity with software version control tools, such as Git.</li>
  //     <li>Excellent problem-solving skills and ability to work in a collaborative, cross-disciplinary team environment.</li>
  //   </ul>
  //   Preferred Qualifications:
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Experience with embedded systems and real-time software development.</li>
  //     <li>Familiarity with multi-threading and parallel computing techniques for processing large-scale data.</li>
  //     <li>Experience working with GPU-accelerated computing for image processing and machine learning tasks.</li>
  //     <li>Familiarity with cloud computing platforms (e.g., AWS, Google Cloud) and distributed computing.</li>
  //   </ul>
  //   Why Join Us?
  //   <ul style={{ listStyleType: 'circle', paddingLeft: '1vw' }}>
  //     <li>Be part of a pioneering team at the forefront of imaging technology and computer vision systems.</li>
  //     <li>Work on exciting projects with cutting-edge technologies in a fast-paced and dynamic environment.</li>
  //     <li>Collaborate with a multidisciplinary team and contribute to the optimization of end-to-end computer vision solutions.</li>
  //     <li>Opportunities for growth, professional development, and the ability to make a significant impact on the company's success.</li>
  //   </ul>`

  // }

  // {
  //   role: 'Account Director, Platform',
  //   location: 'Seoul, South Korea',
  //   description: `Our Sales team has a unique mission to help customers understand the deep 
  //   impact that highly capable AI models can bring to their business and users. 
  //   This role is a mixture of technical understanding, vision, partnership, and value-driven strategy. 
  //   You’ll be a key driver of opportunities through the entire sales cycle, from pipeline generation to closure. 
  //   You’ll work with researchers, engineers, and solution strategists to help customers evolve their industry with AI. 
  //   This role is based either in our San Francisco HQ or remotely in New York City, and may include travel. 
  //   We offer relocation assistance to new employees.`
  // },
  // {
  //   role: 'Applied quantum AI, Senior Software Engineer',
  //   location: 'Busan, South Korea',
  //   description: `We’re hiring an Associate General Counsel to focus on regulatory and legal challenges 
  //   related to AI research and product development. In this role, you’ll provide overall strategy, coordination, 
  //   and execution over ongoing and future regulatory and related legal matters. We need someone who has represented 
  //   a breadth of cases and has experience managing high-stakes regulatory investigations, lawsuits, and other 
  //   regulatory proceedings. This role reports to our Deputy General Counsel.

  //   This role is based in San Francisco, CA. We use a hybrid work model of 3 days in the office per week and 
  //   offer relocation assistance to new employees.`
  // },
  // {
  //   role: 'Media Relations, Asia lead',
  //   location: 'Gyeonggi, South Korea',
  //   description: `We’re looking for an experienced PR professional to join our small, high-impact team to lead media
  //   relations in Europe. This person will be responsible for developing and executing external communication strategies 
  //   to educate press, stakeholders and the general public on our technology, efforts and principles. Working in close 
  //   collaboration with teams across OpenAI, you will oversee narratives and initiatives across individual markets in 
  //   support of the organization's priorities. This role will report to our Head of Public Relations.  

  //   The ideal candidate should bring a strong mix of strategic and tactical comms ownership. Ability to move fast and 
  //   collaboratively on complex issues in a changing environment is critical. Passion for new technology and storytelling is key.`
  // },
  // {
  //   role: 'Associate General Counsel, Regulatory',
  //   location: 'Osaka, Japan',
  //   description: `We’re hiring an Associate General Counsel to focus on regulatory and legal challenges related to 
  //   AI research and product development. In this role, you’ll provide overall strategy, coordination, and execution 
  //   over ongoing and future regulatory and related legal matters. We need someone who has represented a breadth of 
  //   cases and has experience managing high-stakes regulatory investigations, lawsuits, and other regulatory proceedings. 
  //   This role reports to our Deputy General Counsel.

  //   This role is based in San Francisco, CA. We use a hybrid work model of 3 days in the office per week and offer 
  //   relocation assistance to new employees.`
  // },
  // {
  //   role: 'Data engineer',
  //   location: 'San Francisco, U.S.',
  //   description: `We're seeking an experienced data engineering leader to build a world-class data 
  //   engineering team and guide the development of our data architecture. This team is responsible for the 
  //   foundational data assets that empower the rest of the company to leverage data effectively and ultimately 
  //   drive product and business success. The team is responsible for developing key pipelines and core tables 
  //   that are crucial for powering analyses, safety systems that guide business decisions, product growth, 
  //   and prevent bad actors. If you're passionate about working with data and are eager to create solutions 
  //   with significant impact, we'd love to hear from you. This role also provides the opportunity to collaborate 
  //   closely with the researchers behind ChatGPT and help them train new models to deliver to users. 
  //   As we continue our rapid growth, we value data-driven insights, and your contributions will play a pivotal 
  //   role in our trajectory. Join us in shaping the future of OpenAI!`
  // },
  // {
  //   role: 'Staff System engineer',
  //   location: 'New York, U.S.',
  //   description: `As a Distributed Systems/ML engineer, you will work on improving the training throughput 
  //   for our internal training framework, while enabling researchers to experiment with new ideas.  This requires
  //   good engineering (for example designing, implementing, and optimizing state-of-the-art AI models), writing 
  //   bug-free machine learning code (surprisingly difficult!), and acquiring deep knowledge of the performance of 
  //   supercomputers. In all the projects this role pursues, the ultimate goal is to push the field forward.

  //   We’re looking for people who love optimizing performance, understanding distributed systems, and who cannot 
  //   stand having bugs in their code.  Since our training framework is used for large runs with massive numbers of 
  //   GPUs, performance improvements here will have a large impact.
    
  //   This role is based in San Francisco, CA. We use a hybrid work model of 3 days in the office per week and 
  //   offer relocation assistance to new employees.`
  // },
  // {
  //   role: 'Quantum Algorithm, Research Scientist',
  //   location: 'London, U.K.',
  //   description: `In this role, you will work with a small team of software engineers to build primarily the 
  //   infrastructure and compute platform that all of the researchers at OpenAI use for their work.  You do not need 
  //   to be an ML/DL expert to deliver world-class infrastructure, but you do need to be able to quickly obtain a deep 
  //   technical understanding of new domains.  You should enjoy being self-directed and identifying the most important 
  //   problems to solve as the team matures with standardized tools and processes around stability, observability, and scaling.`
  // },
  // {
  //   role: 'Quantum Algorithm, Research Scientist',
  //   location: 'Barcelona, Spain',
  //   description: `In this role, you will work with a small team of software engineers to build primarily the 
  //   infrastructure and compute platform that all of the researchers at OpenAI use for their work.  You do not need 
  //   to be an ML/DL expert to deliver world-class infrastructure, but you do need to be able to quickly obtain a deep 
  //   technical understanding of new domains.  You should enjoy being self-directed and identifying the most important 
  //   problems to solve as the team matures with standardized tools and processes around stability, observability, and scaling.`
  // },
  // {
  //   role: 'Quantum Algorithm, Research Scientist',
  //   location: 'Rome, Italy',
  //   description: `In this role, you will work with a small team of software engineers to build primarily the 
  //   infrastructure and compute platform that all of the researchers at OpenAI use for their work.  You do not need 
  //   to be an ML/DL expert to deliver world-class infrastructure, but you do need to be able to quickly obtain a deep 
  //   technical understanding of new domains.  You should enjoy being self-directed and identifying the most important 
  //   problems to solve as the team matures with standardized tools and processes around stability, observability, and scaling.`
  // },
]

export default data;